import ChartContainer from '../../../Common/Services/charts/apex-charts/ChartContainer';
import usePeopleStratificationComparison from './hooks/usePeopleStratificationComparison';

export const PeopleStratificationComparison = () => {
    const { chartConfig } = usePeopleStratificationComparison();

    return (
        <ChartContainer
            title={"Estratificação do Total de Pessoas"}
            options={chartConfig.options}
            series={chartConfig.series}
            type="bar"
            height={450}
        />
    );
};
